module.exports = __webpack_public_path__ + "img/win-coins-image.png";